import { Autocomplete, TextField } from '@mui/material';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	getGpsrProductTypeReferencesLoad,
	getGpsrProductTypeReferences,
} from 'redux/reducers/gpsr/selectors';

type TProductTypeReferencesAutocompleteProps = {
	valueIndex: number | null;
	setValueIndex: (value: number | null) => void;
};

export const ProductTypeReferencesAutocomplete: FC<TProductTypeReferencesAutocompleteProps> = ({
	valueIndex,
	setValueIndex,
}) => {
	const productTypeReferences = useSelector(getGpsrProductTypeReferences);
	const productTypeReferencesLoading = useSelector(getGpsrProductTypeReferencesLoad);

	const value =
		valueIndex !== null ? (productTypeReferences?.data[valueIndex]?.typeName ?? null) : null;
	const handleChange = (event: any, newValue: string | null) => {
		setValueIndex(
			newValue
				? (productTypeReferences?.data.findIndex(item => item.typeName === newValue) ?? null)
				: null,
		);
	};

	return (
		<Autocomplete
			options={productTypeReferences?.data.map(item => item.typeName) ?? []}
			getOptionLabel={(option: string) => option}
			loading={productTypeReferencesLoading}
			renderInput={inputParams => <TextField {...inputParams} label="Product Type Reference" />}
			size="small"
			value={value}
			onChange={handleChange}
		/>
	);
};
